import {queryWebsite,updateWebsite,createHtml,deleteWebsite,queryWebsiteType,updateWebsiteType} from '@/api/website.js'
import {upload,deleteFile} from "@/api/file.js"

export default {
    name: 'Website',
    data() {
        return {
            pageInfo: {current: 1, siteName: "1"},
            website: {dialogTitle: "", logUrl: ""},
            websiteDialogShow: false,
            websiteTypeDialogShow: false,
            websiteTypeEditPopShow: false,
            websiteType: {dialogTitle: "",},
            webTypePageInfo: {},
            webTypeQueryInfo: {current: 1, size: 300, tagName: ""}
        }
    },
    mounted() {
        this.queryWebsite()
    },
    methods: {
        queryWebsite(){
            queryWebsite({current: this.pageInfo.current}).then(data => {
                this.pageInfo = data.data
            })
        },
        queryWebsiteType(){
            queryWebsiteType(this.webTypeQueryInfo).then(data => {
                this.webTypePageInfo = data.data
            })
        },
        showWebsiteDialog(website){
            if(website){
                website.websiteTypeIds=[]
                for(let i=0;i<website.websiteTypes.length;i++){
                    website.websiteTypeIds.push(website.websiteTypes[i].id)
                }
                this.website=website
                this.website.dialogTitle = "修改"
            }else{
                this.website.dialogTitle = "新增网站"
            }
            this.queryWebsiteType()
            this.websiteDialogShow = true
        },
        showWebsiteTypeDialog(){
            this.queryWebsiteType()
            this.websiteTypeDialogShow = true
        },
        websiteDialogClosed(){
            this.website = this.$options.data().website
        },
        updateWebsite(){
            delete this.website.createTime
            delete this.website.updateTime
            updateWebsite(this.website).then(()=>{
                this.websiteDialogShow = false
                this.queryWebsite()
            })
        },
        createHtml(){
            createHtml().then(()=>{})
        },
        updateWebsiteType(){
            delete this.websiteType.createTime
            delete this.websiteType.updateTime
            updateWebsiteType(this.websiteType).then(()=>{
                this.websiteTypeEditPopShow = false
                this.queryWebsiteType()
            })
        },
        fileUpload(fileObj){
            let param = new FormData();
            param.append('file', fileObj.file);
            upload(param).then((data)=>{
                this.website.logUrl = data.data
            })
        },
        removeFile(file){
            deleteFile(file.url).then(()=>{})
        },
        removeWebsite(id){
            deleteWebsite(id).then(()=>{
                this.queryWebsite()
            })
        }
    }
}